import { css } from '@emotion/css';
import c from 'classnames';

export const largeMenuItemStyles = css`
  &:hover,
  &.Mui-focusVisible:hover,
  &.Mui-focusVisible {
    background-color: var(--bg-hover);
  }

  &:active,
  &.Mui-focusVisible:active {
    background-color: var(--bg-onclick);
  }

  .LargeMenuItem-startIcon-root {
    display: inherit;
  }

  &.Mui-disabled {
    .LargeMenuItem-startIcon {
      fill: var(--disabled);
    }

    .LargeMenuItem-label,
    .LargeMenuItem-description {
      color: var(--disabled);
    }
  }
`;

export const LARGE_MENU_ITEM_CLASSES = {
  description: 'LargeMenuItem-description',
  label: 'LargeMenuItem-label',
  root: c('h-56 py-0 px-12 rounded-8 bg-bg-primary flex items-center', largeMenuItemStyles),
  startIcon: {
    icon: 'LargeMenuItem-startIcon w-32 h-32',
    root: 'LargeMenuItem-startIcon-root -ms-4 me-12 text-icon-active',
  },
};
